import { BOOKINGS_APP_DEF_ID } from '@wix/bookings-uou-domain';
export var DAILY_TIMETABLE_APP_BUILDER_ID = 'drzkv';
export var BOOK_BUTTON_APP_BUILDER_ID = 'flb7a';
export var STAFF_LIST_APP_BUILDER_ID = 'cyng5';
export var DAILY_TIMETABLE_WIDGET_ID = BOOKINGS_APP_DEF_ID + "-" + DAILY_TIMETABLE_APP_BUILDER_ID;
export var STAFF_LIST_WIDGET_ID = BOOKINGS_APP_DEF_ID + "-" + STAFF_LIST_APP_BUILDER_ID;
export var BOOK_BUTTON_WIDGET_ID = BOOKINGS_APP_DEF_ID + "-" + BOOK_BUTTON_APP_BUILDER_ID;
export var DAILY_TIMETABLE_WIDGET_DEV_CENTER_ID = '89c4023a-027e-4d2a-b6b7-0b9d345b508d';
export var STAFF_LIST_WIDGET_DEV_CENTER_ID = '3dc66bc5-5354-4ce6-a436-bd8394c09b0e';
export var BookingsApisBaseUrls = {
    SERVICES_CATALOG: 'https://www.wixapis.com/bookings/v1/service-catalog',
};
var BookingsAppBuilderStaticsBaseUrl = 'https://bookings.wixapps.net/bookings-app-builder-statics';
export var BookingsAppBuilderStaticsUrls = {
    BOOK_BUTTON_SETTINGS: BookingsAppBuilderStaticsBaseUrl + "/book-button/settings",
};
//# sourceMappingURL=platform.const.js.map